import { render } from "./DashboardSpaceDetails.vue?vue&type=template&id=49285e95"
import script from "./DashboardSpaceDetails.vue?vue&type=script&lang=js"
export * from "./DashboardSpaceDetails.vue?vue&type=script&lang=js"
script.render = render

export default script